import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
  Paper,
} from "@mui/material";
import { getFirestore, collection, getDocs, doc, setDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { fonts } from "fonts";

export default function AnnouncementsModal() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const db = getFirestore();
  const auth = getAuth();

  useEffect(() => {
    const fetchAnnouncements = async () => {
      if (!auth.currentUser) return;
      const uid = auth.currentUser.uid;

      // Fetch announcements
      const snapshot = await getDocs(collection(db, "announcements"));
      const unseen = [];

      for (const docSnap of snapshot.docs) {
        const seenRef = doc(db, `users/${uid}/seenAnnouncements/${docSnap.id}`);
        const seenDoc = await getDocs(
          collection(db, `users/${uid}/seenAnnouncements`)
        );
        const alreadySeen = seenDoc.docs.some((d) => d.id === docSnap.id);

        if (!alreadySeen) {
          unseen.push({ id: docSnap.id, ...docSnap.data() });
          // Mark as seen (write only in user's subcollection)
          await setDoc(seenRef, { seenAt: new Date().getTime() });
        }
      }

      if (unseen.length > 0) {
        setAnnouncements(unseen);
        setOpen(true);
      } else {
        console.log("No new announcements to display.");
      }
    };

    fetchAnnouncements();
  }, [auth.currentUser, db]);

  const handleClose = () => setOpen(false);

  const handleAction = (action) => {
    navigate(action.route);    
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Announcements</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1}>
          {announcements.map((a) => (
            <Paper>
              <Stack key={a.id} p={1} spacing={2}>
                <Stack>
                  <Typography variant="h6">{a.title}</Typography>
                  <Typography variant="caption">
                    {new Date(a.createdAt).toLocaleString()}
                  </Typography>
                </Stack>
                <Typography fontFamily={fonts.geist}>{a.message}</Typography>
                {a.action && (
                  <Button onClick={() => handleAction(a.action)} variant="outlined">
                    {a.action.label}
                  </Button>
                )}
              </Stack>
            </Paper>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
